import {
  ACCESS_LEVELS,
} from '@/lib/consts.ts'
import {
  ROUTE_META_PARAMS,
} from '@/router/consts.ts'

import { __t } from '@/lib/helpers'

export default {
  path: 'partner-apps',
  name: 'settings-partner-apps',
  meta: {
    title: __t('routes.settings.partner-apps.title'),
    subtitle: __t('routes.settings.partner-apps.subtitle'),
    icon: 'partner-apps',
    backgroundIcon: 'partner-apps',
    [ROUTE_META_PARAMS.ACCESS_LEVEL]: ACCESS_LEVELS.MANAGER,
    [ROUTE_META_PARAMS.SHOULD_BE_VISIBLE]: (store) => {
      return store.state.business.business.partner_apps_enabled
    },
  },
  component: () => import('@/views/business/settings/partner-apps/index.vue'),
  children: [
    {
      path: ':partnerType',
      name: 'settings-partner-app',
      meta: {
        title: __t('routes.settings.partner-apps.title'),
        subtitle: __t('routes.settings.partner-apps.subtitle'),
        fullWidth: true,
        [ROUTE_META_PARAMS.HIDDEN_IN_SEARCH]: true,
      },
      component: () => import('@/views/business/partner-app.vue'),
    },
  ],
}
